<table
  *ngIf="dprSummary.currentComment || dprSummary.nextComment || (subprojectConfiguration.showExternalPartyComment && dprSummary.externalComment)"
  class="layout-fixed"
>
  <colgroup>
    <col class="width-100" />
  </colgroup>
  <thead>
    <tr>
      <th>
        <h3>{{subprojectConfiguration.customNames.summaryTabName}}</h3>
      </th>
    </tr>
  </thead>
  <tbody class="secondary-header">
    <tr>
      <td i18n="@@report.reportSummary.txtCurrentDprSummary">Current DPR Summary</td>
    </tr>
  </tbody>
  <tbody>
    <tr><td class="white-space-pre-wrap" [innerHTML]="(dprSummary.currentComment | trim) || '-'"></td></tr>
  </tbody>
  <tbody class="secondary-header">
    <tr>
      <td i18n="@@report.reportSummary.txtNext24hPlanning">Next 24h Planning</td>
    </tr>
  </tbody>
  <tbody>
    <tr><td class="white-space-pre-wrap" [innerHTML]="(dprSummary.nextComment | trim) || '-'"></td></tr>
  </tbody>
  <ng-container *ngIf="subprojectConfiguration.showExternalPartyComment">
    <tbody class="secondary-header">
      <tr>
        <td>{{subprojectConfiguration.customNames.externalPartyCommentName}}</td>
      </tr>
    </tbody>
    <tbody>
      <tr><td class="white-space-pre-wrap" [innerHTML]="(dprSummary.externalComment | trim) || '-'"></td></tr>
    </tbody>
  </ng-container>
</table>
